export function onError(error: Error | { message: string }) {
	let message = error.toString()
	// Auth errors
	if (!(error instanceof Error) && error.message) {
		message = error.message
	}
	alert(formatError(message))
}

function formatError(message: string) {
	if (
		message.includes(
			"UserLambdaValidationException: PreTokenGeneration failed with error Not allowed to log in with username and password."
		)
	) {
		message = message.replace("UserLambdaValidationException: PreTokenGeneration failed with error ", "")
	}

	return message
}
